module.exports = __webpack_public_path__ + "static/CamindiLogo-019c0b0ba1a877f0ec0fc9aa682edc9b.svg";